<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card header-->
    <div class="card-header border-0">
      <!--begin::Card title-->
      <div class="card-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="19"
          viewBox="0 0 23 19"
          fill="none"
          style="margin-right: 17px"
        >
          <path
            d="M8.29334 10.3029C7.85065 10.5198 7.45027 10.7908 7.09221 11.1161C6.73414 11.4413 6.43142 11.8176 6.18403 12.2449H7.71719C8.06874 11.8559 8.48539 11.5561 8.96715 11.3457C9.4489 11.1352 9.95996 11.0268 10.5003 11.0204C11.0211 11.0204 11.5061 11.1161 11.9553 11.3074C12.4045 11.4987 12.8017 11.7602 13.1467 12.0918C13.4918 12.4235 13.7619 12.8157 13.9572 13.2685C14.1525 13.7213 14.2502 14.1964 14.2502 14.6939H15.5002C15.5002 14.2283 15.4351 13.7787 15.3048 13.345C15.1746 12.9114 14.9891 12.5 14.7482 12.111C14.5073 11.7219 14.2111 11.3776 13.8596 11.0778C13.508 10.7781 13.1239 10.5198 12.7073 10.3029C13.1955 9.95855 13.5731 9.52806 13.84 9.01148C14.107 8.4949 14.2437 7.94005 14.2502 7.34694C14.2502 7.00893 14.3153 6.69324 14.4455 6.39987C14.5757 6.10651 14.7547 5.84503 14.9826 5.61543C15.2104 5.38584 15.4741 5.21046 15.7736 5.08929C16.0731 4.96811 16.3986 4.90434 16.7501 4.89796C17.0952 4.89796 17.4174 4.96173 17.7169 5.08929C18.0164 5.21684 18.2833 5.39222 18.5176 5.61543C18.752 5.83865 18.931 6.09694 19.0547 6.39031C19.1784 6.68367 19.2435 7.00255 19.25 7.34694H20.5C20.5 7.01531 20.4544 6.69005 20.3633 6.37117C20.2721 6.0523 20.1452 5.75574 19.9824 5.48151C19.8197 5.20727 19.6146 4.95217 19.3672 4.7162C19.1198 4.48023 18.8497 4.28571 18.5567 4.13265C18.778 3.90944 18.9473 3.65115 19.0645 3.35778C19.1817 3.06441 19.2435 2.76148 19.25 2.44898C19.25 2.11097 19.1849 1.79528 19.0547 1.50191C18.9245 1.20855 18.7455 0.947066 18.5176 0.717475C18.2898 0.487883 18.0261 0.3125 17.7266 0.191327C17.4272 0.0701531 17.1017 0.00637755 16.7501 0C16.4051 0 16.0828 0.0637755 15.7833 0.191327C15.4839 0.318878 15.217 0.49426 14.9826 0.717475C14.7482 0.940689 14.5692 1.19898 14.4455 1.49235C14.3218 1.78571 14.2567 2.10459 14.2502 2.44898C14.2502 2.76148 14.3088 3.06441 14.426 3.35778C14.5432 3.65115 14.7157 3.90944 14.9435 4.13265C14.6701 4.27934 14.426 4.45472 14.2111 4.6588C13.9963 4.86288 13.801 5.0861 13.6252 5.32844C13.4494 5.07334 13.2476 4.84375 13.0198 4.63967C12.7919 4.43559 12.5445 4.26339 12.2776 4.12309C12.0107 3.98278 11.7275 3.87117 11.428 3.78827C11.1285 3.70536 10.8193 3.66709 10.5003 3.67347C10.1878 3.67347 9.88183 3.71173 9.58236 3.78827C9.28289 3.8648 8.9997 3.97321 8.73278 4.11352C8.46586 4.25383 8.21522 4.42921 7.98085 4.63967C7.74648 4.85013 7.54467 5.07972 7.3754 5.32844C7.20613 5.0861 7.01408 4.86288 6.79925 4.6588C6.58441 4.45472 6.33702 4.27934 6.05708 4.13265C6.27843 3.90944 6.44769 3.65115 6.56488 3.35778C6.68206 3.06441 6.74391 2.76148 6.75042 2.44898C6.75042 2.11097 6.68532 1.79528 6.55511 1.50191C6.42491 1.20855 6.24588 0.947066 6.01802 0.717475C5.79016 0.487883 5.5265 0.3125 5.22703 0.191327C4.92756 0.0701531 4.60205 0.00637755 4.2505 0C3.90545 0 3.5832 0.0637755 3.28373 0.191327C2.98426 0.318878 2.71734 0.49426 2.48297 0.717475C2.2486 0.940689 2.06957 1.19898 1.94588 1.49235C1.82219 1.78571 1.75708 2.10459 1.75057 2.44898C1.75057 2.76148 1.80916 3.06441 1.92635 3.35778C2.04353 3.65115 2.21605 3.90944 2.44391 4.13265C2.14444 4.29209 1.87427 4.48661 1.63339 4.7162C1.39251 4.94579 1.19069 5.1977 1.02794 5.47194C0.865183 5.74617 0.734978 6.04592 0.637325 6.37117C0.539671 6.69643 0.494101 7.02168 0.50061 7.34694H1.75057C1.75057 7.00893 1.81567 6.69324 1.94588 6.39987C2.07608 6.10651 2.25511 5.84503 2.48297 5.61543C2.71083 5.38584 2.97449 5.21046 3.27396 5.08929C3.57343 4.96811 3.89894 4.90434 4.2505 4.89796C4.59554 4.89796 4.91779 4.96173 5.21726 5.08929C5.51673 5.21684 5.78365 5.39222 6.01802 5.61543C6.25239 5.83865 6.43142 6.09694 6.55511 6.39031C6.67881 6.68367 6.74391 7.00255 6.75042 7.34694C6.75042 7.93367 6.88388 8.48533 7.1508 9.00191C7.41772 9.51849 7.79856 9.95217 8.29334 10.3029ZM4.2505 1.22449C4.42627 1.22449 4.58903 1.25638 4.73876 1.32015C4.8885 1.38393 5.0187 1.47003 5.12938 1.57844C5.24005 1.68686 5.33119 1.8176 5.4028 1.97066C5.47442 2.12372 5.50697 2.28316 5.50046 2.44898C5.50046 2.62117 5.46791 2.78061 5.4028 2.9273C5.3377 3.07398 5.24981 3.20153 5.13914 3.30995C5.02847 3.41837 4.89501 3.50765 4.73876 3.57781C4.58252 3.64796 4.41976 3.67985 4.2505 3.67347C4.07472 3.67347 3.91196 3.64158 3.76223 3.57781C3.6125 3.51403 3.48229 3.42793 3.37162 3.31952C3.26094 3.2111 3.1698 3.08036 3.09819 2.9273C3.02658 2.77423 2.99402 2.6148 3.00053 2.44898C3.00053 2.27679 3.03308 2.11735 3.09819 1.97066C3.16329 1.82398 3.25118 1.69643 3.36185 1.58801C3.47252 1.47959 3.60598 1.39031 3.76223 1.32015C3.91847 1.25 4.08123 1.21811 4.2505 1.22449ZM16.7501 3.67347C16.5743 3.67347 16.4116 3.64158 16.2618 3.57781C16.1121 3.51403 15.9819 3.42793 15.8712 3.31952C15.7606 3.2111 15.6694 3.08036 15.5978 2.9273C15.5262 2.77423 15.4936 2.6148 15.5002 2.44898C15.5002 2.27679 15.5327 2.11735 15.5978 1.97066C15.6629 1.82398 15.7508 1.69643 15.8615 1.58801C15.9721 1.47959 16.1056 1.39031 16.2618 1.32015C16.4181 1.25 16.5808 1.21811 16.7501 1.22449C16.9259 1.22449 17.0886 1.25638 17.2384 1.32015C17.3881 1.38393 17.5183 1.47003 17.629 1.57844C17.7397 1.68686 17.8308 1.8176 17.9024 1.97066C17.974 2.12372 18.0066 2.28316 18.0001 2.44898C18.0001 2.62117 17.9675 2.78061 17.9024 2.9273C17.8373 3.07398 17.7494 3.20153 17.6388 3.30995C17.5281 3.41837 17.3946 3.50765 17.2384 3.57781C17.0821 3.64796 16.9194 3.67985 16.7501 3.67347ZM10.5003 9.79592C10.1553 9.79592 9.83301 9.73214 9.53354 9.60459C9.23407 9.47704 8.96715 9.30166 8.73278 9.07844C8.49841 8.85523 8.31938 8.59694 8.19569 8.30357C8.07199 8.0102 8.00689 7.69133 8.00038 7.34694C8.00038 7.00893 8.06548 6.69324 8.19569 6.39987C8.32589 6.10651 8.50492 5.84503 8.73278 5.61543C8.96064 5.38584 9.2243 5.21046 9.52377 5.08929C9.82324 4.96811 10.1488 4.90434 10.5003 4.89796C10.8453 4.89796 11.1676 4.96173 11.4671 5.08929C11.7665 5.21684 12.0335 5.39222 12.2678 5.61543C12.5022 5.83865 12.6812 6.09694 12.8049 6.39031C12.9286 6.68367 12.9937 7.00255 13.0002 7.34694C13.0002 7.68495 12.9351 8.00064 12.8049 8.29401C12.6747 8.58737 12.4957 8.84885 12.2678 9.07844C12.04 9.30804 11.7763 9.48342 11.4768 9.60459C11.1774 9.72577 10.8519 9.78954 10.5003 9.79592ZM3.00053 13.4694H0.50061V14.6939H3.00053V17.1429H4.2505V14.6939H6.75042V13.4694H4.2505V11.0204H3.00053V13.4694Z"
            fill="#006C90"
          />
        </svg>
        Grupos
      </div>
      <!--begin::Card title-->
    </div>
    <!--end::Card header-->

    <!--begin: Card-body Drag and Drop-->
    <div class="card-body col-12">
      <div id="card-filter" class="col-12 row">
        <div class="col-12 col-md-6 col-xl-4	col-xxl-4">
          <label for="nombreGrupo" class="col-12">Nombre</label>
          <input type="text" id="nombreGrupo" v-model="nombreGrupo" class="col-12 form-control" />
        </div>
        <div class="col-12 col-md-6 col-xl-2	col-xxl-2">
          <label for="fechaDesde" class="col-12">Fecha Desde</label>
          <input type="date" id="fechaDesde" v-model="fechaDesde" class="col-12 form-control" />
        </div>
        <div class="col-12 col-md-6 col-xl-2	col-xxl-2">
          <label for="fechaHasta" class="col-12">Fecha Hasta</label>
          <input type="date" id="fechaHasta" v-model="fechaHasta" class="col-12 form-control" />
        </div>
        <div class="buttons-filter col-12 col-xl-4 col-xxl-4">
          <div class="col-12 col-md-6">
            <button class="btn btn-melon col-12" @click="filtrarItems">Filtrar</button>
          </div>
          <div class="col-12 col-md-6">
            <button class="btn btn-melon-secundario col-12" @click="cargarValoresIniciales">
              Limpiar
            </button>
          </div>
        </div>
      </div>
      <div id="botonera" class="col-12">
        <div id="button-eliminar">
          <button
            v-if="!selectEliminar"
            style="background-color: #99c4d3; border-color: #99c4d3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              style="margin-right: 7px"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.25 3V1.5H10.75V3H6.25ZM4.75 3V1C4.75 0.734784 4.85536 0.48043 5.04289 0.292893C5.23043 0.105357 5.48478 0 5.75 0L11.25 0C11.5152 0 11.7696 0.105357 11.9571 0.292893C12.1446 0.48043 12.25 0.734784 12.25 1V3H14.75C14.9489 3 15.1397 3.07902 15.2803 3.21967C15.421 3.36032 15.5 3.55109 15.5 3.75C15.5 3.94891 15.421 4.13968 15.2803 4.28033C15.1397 4.42098 14.9489 4.5 14.75 4.5H14.385L13.642 14.153C13.6034 14.6554 13.3767 15.1248 13.007 15.4673C12.6373 15.8097 12.1519 16 11.648 16H5.352C4.84808 16 4.36274 15.8097 3.99304 15.4673C3.62335 15.1248 3.39655 14.6554 3.358 14.153L2.615 4.5H2.25C2.05109 4.5 1.86032 4.42098 1.71967 4.28033C1.57902 4.13968 1.5 3.94891 1.5 3.75C1.5 3.55109 1.57902 3.36032 1.71967 3.21967C1.86032 3.07902 2.05109 3 2.25 3H4.75ZM4.12 4.5H12.88L12.146 14.038C12.1364 14.1636 12.0798 14.2809 11.9875 14.3666C11.8952 14.4522 11.7739 14.4999 11.648 14.5H5.352C5.22607 14.4999 5.10482 14.4522 5.0125 14.3666C4.92017 14.2809 4.86357 14.1636 4.854 14.038L4.12 4.5Z"
                fill="white"
              />
            </svg>
            Eliminar
          </button>
          <button @click="eliminarFilas" v-if="selectEliminar">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              style="margin-right: 7px"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.25 3V1.5H10.75V3H6.25ZM4.75 3V1C4.75 0.734784 4.85536 0.48043 5.04289 0.292893C5.23043 0.105357 5.48478 0 5.75 0L11.25 0C11.5152 0 11.7696 0.105357 11.9571 0.292893C12.1446 0.48043 12.25 0.734784 12.25 1V3H14.75C14.9489 3 15.1397 3.07902 15.2803 3.21967C15.421 3.36032 15.5 3.55109 15.5 3.75C15.5 3.94891 15.421 4.13968 15.2803 4.28033C15.1397 4.42098 14.9489 4.5 14.75 4.5H14.385L13.642 14.153C13.6034 14.6554 13.3767 15.1248 13.007 15.4673C12.6373 15.8097 12.1519 16 11.648 16H5.352C4.84808 16 4.36274 15.8097 3.99304 15.4673C3.62335 15.1248 3.39655 14.6554 3.358 14.153L2.615 4.5H2.25C2.05109 4.5 1.86032 4.42098 1.71967 4.28033C1.57902 4.13968 1.5 3.94891 1.5 3.75C1.5 3.55109 1.57902 3.36032 1.71967 3.21967C1.86032 3.07902 2.05109 3 2.25 3H4.75ZM4.12 4.5H12.88L12.146 14.038C12.1364 14.1636 12.0798 14.2809 11.9875 14.3666C11.8952 14.4522 11.7739 14.4999 11.648 14.5H5.352C5.22607 14.4999 5.10482 14.4522 5.0125 14.3666C4.92017 14.2809 4.86357 14.1636 4.854 14.038L4.12 4.5Z"
                fill="white"
              />
            </svg>
            Eliminar
          </button>
        </div>
        <div id="button-nuevo">
          <button @click="nuevoGrupo = true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="18"
              viewBox="0 0 21 18"
              fill="none"
              style="margin-right: 7px"
            >
              <path
                d="M8.29334 10.3029C7.85065 10.5198 7.45027 10.7908 7.09221 11.1161C6.73414 11.4413 6.43142 11.8176 6.18403 12.2449H7.71719C8.06874 11.8559 8.48539 11.5561 8.96715 11.3457C9.4489 11.1352 9.95996 11.0268 10.5003 11.0204C11.0211 11.0204 11.5061 11.1161 11.9553 11.3074C12.4045 11.4987 12.8017 11.7602 13.1467 12.0918C13.4918 12.4235 13.7619 12.8157 13.9572 13.2685C14.1525 13.7213 14.2502 14.1964 14.2502 14.6939H15.5002C15.5002 14.2283 15.4351 13.7787 15.3048 13.345C15.1746 12.9114 14.9891 12.5 14.7482 12.111C14.5073 11.7219 14.2111 11.3776 13.8596 11.0778C13.508 10.7781 13.1239 10.5198 12.7073 10.3029C13.1955 9.95855 13.5731 9.52806 13.84 9.01148C14.107 8.4949 14.2437 7.94005 14.2502 7.34694C14.2502 7.00893 14.3153 6.69324 14.4455 6.39987C14.5757 6.10651 14.7547 5.84503 14.9826 5.61543C15.2104 5.38584 15.4741 5.21046 15.7736 5.08929C16.0731 4.96811 16.3986 4.90434 16.7501 4.89796C17.0952 4.89796 17.4174 4.96173 17.7169 5.08929C18.0164 5.21684 18.2833 5.39222 18.5176 5.61543C18.752 5.83865 18.931 6.09694 19.0547 6.39031C19.1784 6.68367 19.2435 7.00255 19.25 7.34694H20.5C20.5 7.01531 20.4544 6.69005 20.3633 6.37117C20.2721 6.0523 20.1452 5.75574 19.9824 5.48151C19.8197 5.20727 19.6146 4.95217 19.3672 4.7162C19.1198 4.48023 18.8497 4.28571 18.5567 4.13265C18.778 3.90944 18.9473 3.65115 19.0645 3.35778C19.1817 3.06441 19.2435 2.76148 19.25 2.44898C19.25 2.11097 19.1849 1.79528 19.0547 1.50191C18.9245 1.20855 18.7455 0.947066 18.5176 0.717475C18.2898 0.487883 18.0261 0.3125 17.7266 0.191327C17.4272 0.0701531 17.1017 0.00637755 16.7501 0C16.4051 0 16.0828 0.0637755 15.7833 0.191327C15.4839 0.318878 15.217 0.49426 14.9826 0.717475C14.7482 0.940689 14.5692 1.19898 14.4455 1.49235C14.3218 1.78571 14.2567 2.10459 14.2502 2.44898C14.2502 2.76148 14.3088 3.06441 14.426 3.35778C14.5432 3.65115 14.7157 3.90944 14.9435 4.13265C14.6701 4.27934 14.426 4.45472 14.2111 4.6588C13.9963 4.86288 13.801 5.0861 13.6252 5.32844C13.4494 5.07334 13.2476 4.84375 13.0198 4.63967C12.7919 4.43559 12.5445 4.26339 12.2776 4.12309C12.0107 3.98278 11.7275 3.87117 11.428 3.78827C11.1285 3.70536 10.8193 3.66709 10.5003 3.67347C10.1878 3.67347 9.88183 3.71173 9.58236 3.78827C9.28289 3.8648 8.9997 3.97321 8.73278 4.11352C8.46586 4.25383 8.21522 4.42921 7.98085 4.63967C7.74648 4.85013 7.54467 5.07972 7.3754 5.32844C7.20613 5.0861 7.01408 4.86288 6.79925 4.6588C6.58441 4.45472 6.33702 4.27934 6.05708 4.13265C6.27843 3.90944 6.44769 3.65115 6.56488 3.35778C6.68206 3.06441 6.74391 2.76148 6.75042 2.44898C6.75042 2.11097 6.68532 1.79528 6.55511 1.50191C6.42491 1.20855 6.24588 0.947066 6.01802 0.717475C5.79016 0.487883 5.5265 0.3125 5.22703 0.191327C4.92756 0.0701531 4.60205 0.00637755 4.2505 0C3.90545 0 3.5832 0.0637755 3.28373 0.191327C2.98426 0.318878 2.71734 0.49426 2.48297 0.717475C2.2486 0.940689 2.06957 1.19898 1.94588 1.49235C1.82219 1.78571 1.75708 2.10459 1.75057 2.44898C1.75057 2.76148 1.80916 3.06441 1.92635 3.35778C2.04353 3.65115 2.21605 3.90944 2.44391 4.13265C2.14444 4.29209 1.87427 4.48661 1.63339 4.7162C1.39251 4.94579 1.19069 5.1977 1.02794 5.47194C0.865183 5.74617 0.734978 6.04592 0.637325 6.37117C0.539671 6.69643 0.494101 7.02168 0.50061 7.34694H1.75057C1.75057 7.00893 1.81567 6.69324 1.94588 6.39987C2.07608 6.10651 2.25511 5.84503 2.48297 5.61543C2.71083 5.38584 2.97449 5.21046 3.27396 5.08929C3.57343 4.96811 3.89894 4.90434 4.2505 4.89796C4.59554 4.89796 4.91779 4.96173 5.21726 5.08929C5.51673 5.21684 5.78365 5.39222 6.01802 5.61543C6.25239 5.83865 6.43142 6.09694 6.55511 6.39031C6.67881 6.68367 6.74391 7.00255 6.75042 7.34694C6.75042 7.93367 6.88388 8.48533 7.1508 9.00191C7.41772 9.51849 7.79856 9.95217 8.29334 10.3029ZM4.2505 1.22449C4.42627 1.22449 4.58903 1.25638 4.73876 1.32015C4.8885 1.38393 5.0187 1.47003 5.12938 1.57844C5.24005 1.68686 5.33119 1.8176 5.4028 1.97066C5.47442 2.12372 5.50697 2.28316 5.50046 2.44898C5.50046 2.62117 5.46791 2.78061 5.4028 2.9273C5.3377 3.07398 5.24981 3.20153 5.13914 3.30995C5.02847 3.41837 4.89501 3.50765 4.73876 3.57781C4.58252 3.64796 4.41976 3.67985 4.2505 3.67347C4.07472 3.67347 3.91196 3.64158 3.76223 3.57781C3.6125 3.51403 3.48229 3.42793 3.37162 3.31952C3.26094 3.2111 3.1698 3.08036 3.09819 2.9273C3.02658 2.77423 2.99402 2.6148 3.00053 2.44898C3.00053 2.27679 3.03308 2.11735 3.09819 1.97066C3.16329 1.82398 3.25118 1.69643 3.36185 1.58801C3.47252 1.47959 3.60598 1.39031 3.76223 1.32015C3.91847 1.25 4.08123 1.21811 4.2505 1.22449ZM16.7501 3.67347C16.5743 3.67347 16.4116 3.64158 16.2618 3.57781C16.1121 3.51403 15.9819 3.42793 15.8712 3.31952C15.7606 3.2111 15.6694 3.08036 15.5978 2.9273C15.5262 2.77423 15.4936 2.6148 15.5002 2.44898C15.5002 2.27679 15.5327 2.11735 15.5978 1.97066C15.6629 1.82398 15.7508 1.69643 15.8615 1.58801C15.9721 1.47959 16.1056 1.39031 16.2618 1.32015C16.4181 1.25 16.5808 1.21811 16.7501 1.22449C16.9259 1.22449 17.0886 1.25638 17.2384 1.32015C17.3881 1.38393 17.5183 1.47003 17.629 1.57844C17.7397 1.68686 17.8308 1.8176 17.9024 1.97066C17.974 2.12372 18.0066 2.28316 18.0001 2.44898C18.0001 2.62117 17.9675 2.78061 17.9024 2.9273C17.8373 3.07398 17.7494 3.20153 17.6388 3.30995C17.5281 3.41837 17.3946 3.50765 17.2384 3.57781C17.0821 3.64796 16.9194 3.67985 16.7501 3.67347ZM10.5003 9.79592C10.1553 9.79592 9.83301 9.73214 9.53354 9.60459C9.23407 9.47704 8.96715 9.30166 8.73278 9.07844C8.49841 8.85523 8.31938 8.59694 8.19569 8.30357C8.07199 8.0102 8.00689 7.69133 8.00038 7.34694C8.00038 7.00893 8.06548 6.69324 8.19569 6.39987C8.32589 6.10651 8.50492 5.84503 8.73278 5.61543C8.96064 5.38584 9.2243 5.21046 9.52377 5.08929C9.82324 4.96811 10.1488 4.90434 10.5003 4.89796C10.8453 4.89796 11.1676 4.96173 11.4671 5.08929C11.7665 5.21684 12.0335 5.39222 12.2678 5.61543C12.5022 5.83865 12.6812 6.09694 12.8049 6.39031C12.9286 6.68367 12.9937 7.00255 13.0002 7.34694C13.0002 7.68495 12.9351 8.00064 12.8049 8.29401C12.6747 8.58737 12.4957 8.84885 12.2678 9.07844C12.04 9.30804 11.7763 9.48342 11.4768 9.60459C11.1774 9.72577 10.8519 9.78954 10.5003 9.79592ZM3.00053 13.4694H0.50061V14.6939H3.00053V17.1429H4.2505V14.6939H6.75042V13.4694H4.2505V11.0204H3.00053V13.4694Z"
                fill="white"
              />
            </svg>
            Crear Grupos
          </button>
        </div>
      </div>
      <div class="contenedor-table">
        <table class="table table-striped">
          <thead class="thead-document">
            <tr>
              <th scope="col col-2" class="th-1">
                <input type="checkbox" id="header-checkbox" v-model="selectAll" />
              </th>
              <th scope="col" class="">Nombre del Grupo s</th>
              <th scope="col" class="">Fecha Creación</th>
              <th scope="col" class=""></th>
              <th scope="col" class="th-5"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <th scope="col" class="text-center" v-if="item.Activo">
                <input
                  type="checkbox"
                  :id="'checkbox' + index"
                  v-model="item.selected"
                  @click="EliminarBox(!item.selected)"
                />
              </th>
              <th scope="col" v-if="item.Activo">{{ item.nombreGrupo }}</th>
                <th scope="col" v-if="item.Activo">{{ formatearFecha(item.fechaCreacion) }}</th>
              <th scope="col" class="th-actions" v-if="item.Activo">
                <div
                  class="actions"
                  @click="infoGroup(item.id, item.nombreGrupo)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.99967 7.5C10.6627 7.5 11.2986 7.76339 11.7674 8.23223C12.2363 8.70107 12.4997 9.33696 12.4997 10C12.4997 10.663 12.2363 11.2989 11.7674 11.7678C11.2986 12.2366 10.6627 12.5 9.99967 12.5C9.33663 12.5 8.70075 12.2366 8.23191 11.7678C7.76307 11.2989 7.49967 10.663 7.49967 10C7.49967 9.33696 7.76307 8.70107 8.23191 8.23223C8.70075 7.76339 9.33663 7.5 9.99967 7.5ZM9.99967 3.75C14.1663 3.75 17.7247 6.34167 19.1663 10C17.7247 13.6583 14.1663 16.25 9.99967 16.25C5.83301 16.25 2.27467 13.6583 0.833008 10C2.27467 6.34167 5.83301 3.75 9.99967 3.75ZM2.64967 10C3.32322 11.3753 4.3691 12.534 5.66841 13.3444C6.96772 14.1548 8.46834 14.5844 9.99967 14.5844C11.531 14.5844 13.0316 14.1548 14.3309 13.3444C15.6303 12.534 16.6761 11.3753 17.3497 10C16.6761 8.62474 15.6303 7.46604 14.3309 6.65562C13.0316 5.8452 11.531 5.41557 9.99967 5.41557C8.46834 5.41557 6.96772 5.8452 5.66841 6.65562C4.3691 7.46604 3.32322 8.62474 2.64967 10Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </th>
            
              <th scope="col" class="th-actions" v-if="item.Activo">
                <div
                  class="actions"
                  @click="editGroup(item.id, item.nombreGrupo)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_195_290)">
                      <path
                        d="M10.8333 2.5C11.0457 2.50024 11.25 2.58157 11.4045 2.72737C11.5589 2.87318 11.6519 3.07246 11.6643 3.2845C11.6768 3.49653 11.6078 3.70532 11.4714 3.86819C11.3351 4.03107 11.1417 4.13575 10.9308 4.16083L10.8333 4.16667H4.16667V15.8333H15.8333V9.16667C15.8336 8.95427 15.9149 8.74997 16.0607 8.59553C16.2065 8.44108 16.4058 8.34814 16.6178 8.33569C16.8299 8.32324 17.0386 8.39223 17.2015 8.52855C17.3644 8.66488 17.4691 8.85825 17.4942 9.06917L17.5 9.16667V15.8333C17.5001 16.2538 17.3413 16.6588 17.0554 16.9671C16.7695 17.2754 16.3776 17.4643 15.9583 17.4958L15.8333 17.5H4.16667C3.74619 17.5001 3.34119 17.3413 3.03288 17.0554C2.72456 16.7695 2.5357 16.3776 2.50417 15.9583L2.5 15.8333V4.16667C2.49987 3.74619 2.65867 3.34119 2.94458 3.03288C3.23049 2.72456 3.62237 2.5357 4.04167 2.50417L4.16667 2.5H10.8333ZM16.0358 2.78583C16.1858 2.63638 16.387 2.54961 16.5987 2.54314C16.8103 2.53668 17.0164 2.61101 17.1752 2.75104C17.334 2.89107 17.4336 3.08629 17.4537 3.29706C17.4737 3.50783 17.4128 3.71834 17.2833 3.88583L17.2142 3.965L8.96417 12.2142C8.8142 12.3636 8.61297 12.4504 8.40135 12.4569C8.18972 12.4633 7.98357 12.389 7.82477 12.249C7.66596 12.1089 7.56641 11.9137 7.54633 11.7029C7.52626 11.4922 7.58716 11.2817 7.71667 11.1142L7.78583 11.0358L16.0358 2.78583Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_195_290">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <!--end: Drag and Drop-->

      <!--Modal Exito-->
      <transition name="fade">
        <div class="modal-overlay" v-if="showModalExito">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <p class="modal-title" id="exampleModalLabel">Felicitaciones!!!</p>
                <button
                  type="button"
                  class="closeModel"
                  data-dismiss="modal"
                  aria-label="Cerrar"
                  @click="showModalExito = false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <circle cx="15" cy="15" r="15" fill="#006C90" />
                    <path
                      d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
              <div class="modal-body">
                <p>{{ mensajeExito }}</p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-guardar"
                  @click="showModalExito = false"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!--Modal Error-->
      <transition name="fade">
        <div class="modal-overlay" v-if="showModalError">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <p class="modal-title header-error" id="exampleModalLabel">
                  ERROR
                </p>
                <button
                  type="button"
                  class="closeModel"
                  data-dismiss="modal"
                  aria-label="Cerrar"
                  @click="showModalError = false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <circle cx="15" cy="15" r="15" fill="#006C90" />
                    <path
                      d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
              <div class="modal-body">
                <p>{{ mensajeError }}</p>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-melon"
                  @click="showModalError = false"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--end: Drag and Drop-->
    </div>
    <!--end::Card body-->
    <!-- <Loading v-if="carga"></Loading> -->
    <Loading v-if="loading"></Loading>
    <NewGroup
      v-if="nuevoGrupo"
      @cancelar="nuevoGrupo = false"
      @guardar="guardar"
    ></NewGroup>
    <ViewGroup
      v-if="verGrupo"
      @cancelar="verGrupo = false"
      :memsaje="idGrupo"
      :nombre="nombre"
    ></ViewGroup>
    <EditGroup
      v-if="editarGrupo"
      @cancelar="editarGrupo = false"
      @editar="editar"
      :idGrupo="idGrupo"
      :nombre="nombre"
    ></EditGroup>
  </div>
  <!--end::Card-->
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";
import NewGroup from "@/components/group/newGroup.vue";
import ViewGroup from "@/components/group/viewGroup.vue";
import EditGroup from "@/components/group/editGroup.vue";

export default {
  name: "Documents",
  components: {
    Loading,
    NewGroup,
    ViewGroup,
    EditGroup,
  },
  setup() {
    const store = useStore();
    const selectAll = ref(false);
    const items = ref([]);
    const selectedGroup = ref(null);
    const result = ref([]);

    // const carga = ref(true);

    const cargarItems = async () => {
      try {
        const data = await store.dispatch(Actions.GET_GROUPS);
        const documentos = [];
        data.forEach((item) => {
          if (
            !(item.Id === "00000000-0000-0000-0000-000000000001") ||
            item.Nombre === "Todos"
          ) {
            documentos.push({
              id: item.Id,
              nombreGrupo: item.Nombre,
              proveedores: item.proveedores,
              selected: false,
              Activo: item.activo,
              fechaCreacion: item.fechaCreacion,
              idGrupo: "",
              nombre: "",
            });
          }
        });
        const result = documentos.map((proxy) => ({ ...proxy }));

        // Asigna result a la variable items
        items.value = result;
      } catch (error) {
        console.error(error);
      }
    };

    const fetchItems = async () => {
      try {
        const documentos = [];
        const data = await store.dispatch(Actions.GET_GROUPS);
        data.forEach((item) => {
          if (
            !(item.Id === "00000000-0000-0000-0000-000000000001") ||
            item.Nombre === "Todos"
          ) {
            documentos.push({
              id: item.Id,
              nombreGrupo: item.Nombre,
              proveedores: item.proveedores,
               fechaCreacion: item.fechaCreacion,
              selected: false,
              Activo: item.activo,
            });
          }
        });
        result.value = documentos;
        // carga.value = false;
        // Llama a cargarItems para cargar los datos en items
        cargarItems();
      } catch (error) {
        console.error(error);
        // carga.value = false;  
      }
    };
 const formatearFecha = (fecha) => {
            const fechaFormato = new Date(fecha);
            var dia = fechaFormato.getDate();
            var mes = fechaFormato.getMonth() + 1; // Los meses en JavaScript son indexados desde 0
            var anio = fechaFormato.getFullYear();

            // Formatear la cadena en el nuevo formato
            return `${dia < 10 ? "0" : ""}${dia}/${
                mes < 10 ? "0" : ""
            }${mes}/${anio}`;
        };
    fetchItems();

    return {
      selectAll,
      items,
      selectedGroup,
      result,
      formatearFecha
    };
  },
  data() {
    return {
      fechaDesde: null,
      fechaHasta: null,
      nombreGrupo: null,
      store: useStore(),
      loading: false,
      showModalExito: false,
      showModalError: false,
      mensajeError: "",
      mensajeExito: "",
      selectEliminar: false,
      nuevoGrupo: false,
      verGrupo: false,
      editarGrupo: false,
      idGrupo: "",
    };
  },
  methods: {
    async eliminarFilas() {
      const deleteList = [];
      this.loading = true;
      try {
        this.items.forEach(async (item) => {
          if (item.selected) {
            item.Activo = false;
            deleteList.push(item.id);
          }
        });
        var formData = new FormData();
        formData.append("values", JSON.stringify(deleteList));

        const data = await this.store.dispatch(Actions.DELETE_GROUPS, formData);
        this.mensajeExito = "Los Grupos han sido eliminados exitosamente.";
        this.showModalExito = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.mensajeError = "Error al al intentar eliminar los grupos.";
        this.showModalError = true;
        console.log(error);
      }
      this.selectEliminar = false;
      //items.value = items.value.filter((item) => !item.selected);
    },
    cargarValoresIniciales() {
      this.items = this.result.map((proxy) => {
        return { ...proxy };
      });
      this.nombreGrupo = "";
      this.fechaDesde = "";
      this.fechaHasta = "";
    },

    filtrarItems() {
       this.items = this.result.map((proxy) => {
        return { ...proxy };
      });


      const fechaDesde = this.fechaDesde ? new Date(this.fechaDesde).getTime() : null;
      const fechaHasta = this.fechaHasta ? new Date(this.fechaHasta).getTime() : null;

      const nombreGrupo = this.nombreGrupo !== null ? this.nombreGrupo : null;

      this.items = this.items.filter((item) => {

        const fechaCreacion = new Date(item.fechaCreacion).getTime();
        const nombreItem = item.nombreGrupo;
 
        const fechaValida = (!fechaDesde || fechaCreacion >= fechaDesde) && (!fechaHasta || fechaCreacion <= fechaHasta);


        const nombreCargaValido =
          nombreGrupo === null ||
          nombreItem.toUpperCase().includes(nombreGrupo.toUpperCase());

        if (fechaValida && nombreCargaValido) {
    
          item.fechaCreacion = item.fechaCreacion;
          item.fechaLimite = item.fechaLimite;
        }

        return fechaValida && nombreCargaValido;
  
     });
  },
    Eliminar() {
      var aux = false;
      const values = this.items.map((proxy) => {
        return { ...proxy };
      });

      values.forEach((item) => {
        if (item.selected) {
          aux = aux || true;
        }
      });
      this.selectEliminar = aux;
      return this.selectEliminar;
    },
    EliminarBox(check) {
      if (check) {
        this.selectEliminar = true;
      } else {
        var aux = 0;
        const values = this.items.map((proxy) => {
          return { ...proxy };
        });

        values.forEach((item) => {
          if (item.selected) {
            aux += 1;
          }
        });
        this.selectEliminar = aux <= 1 ? false : true;
      }
      return this.selectEliminar;
    },
    async guardar(files) {
      if (files == null) {
        this.mensajeError =
          "No fue posible crear el grupo. Intenta nuevamente.";
        this.showModalError = true;
        this.nuevoGrupo = false;
      } else {
        try {
          const data = await this.store.dispatch(Actions.GET_GROUPS);
          const documentos = [];
          data.forEach((item) => {
            if (
              !(item.Id === "00000000-0000-0000-0000-000000000001") ||
              item.Nombre === "Todos"
            ) {
              documentos.push({
                id: item.Id,
                nombreGrupo: item.Nombre,
                proveedores: item.proveedores,
                selected: false,
                Activo: item.activo,
              });
            }
          });
          const result = documentos.map((proxy) => ({ ...proxy }));

          // Asigna result a la variable items
          this.items = result;
          this.mensajeExito =
            "Se creo el grupo de manera correcta";
          this.showModalExito = true;
          this.nuevoGrupo = false;
        } catch (error) {
          console.error(error);
        }
      }
    },
    async editar(files) {
      if (files == null) {
        this.mensajeError =
          "No fue posible editar el grupo. Intenta nuevamente.";
        this.showModalError = true;
        this.editarGrupo = false;
      } else {
        try {
          const data = await this.store.dispatch(Actions.GET_GROUPS);
          const documentos = [];
          data.forEach((item) => {
            if (
              !(item.Id === "00000000-0000-0000-0000-000000000001") ||
              item.Nombre === "Todos"
            ) {
              documentos.push({
                id: item.Id,
                nombreGrupo: item.Nombre,
                proveedores: item.proveedores,
                selected: false,
                Activo: item.activo,
              });
            }
          });
          const result = documentos.map((proxy) => ({ ...proxy }));

          // Asigna result a la variable items
          this.items = result;
          this.mensajeExito = "Se edito el grupo de manera correcta";
          this.showModalExito = true;
          this.editarGrupo = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    infoGroup(id, nombre) {
      this.idGrupo = id.toString();
      this.nombre = nombre.toString();
      this.verGrupo = true;
    },

    editGroup(id, nombre) {
      console.log(id, nombre);
      this.idGrupo = id.toString();
      this.nombre = nombre.toString();
      this.editarGrupo = true;
    },
  },
  watch: {
    selectAll: function (value) {
      this.items.forEach((item) => {
        item.selected = value;
      });
      this.Eliminar();
    },
  },
  computed: {},
};
</script>

<style scoped>
.contenedor-table {
  overflow-x: auto; 
  white-space: nowrap; 
}

.btn-error {
  color: white;
  background-color: red;
}

.btn-guardar {
  display: flex;
  width: 120px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.actions {
  width: 30px;
  height: 30px;
  background: #006c90;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
}
/* .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
} */
/* 
.modal-dialog {
  position: fixed !important;
  width: 35rem;
  top: 50px;
}

.modal-header {
  height: 60px;
}
 */




.btn-guardar {
  display: flex;
  width: 140px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.modal-footer {
  padding: 0px 1.5rem 1.5rem 0px !important;
  border: 0px !important;
}

#card-filter {
  background-color: #fff;
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  padding-top: 13px;
  padding-left: 18px;
  padding-bottom: 9px;
}

#card-filter label {
  color: #006c90;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.buttons-filter {
  justify-content: center;
  align-items: center;
  flex-direction: inherit !important;
}

.buttons-filter button {
  margin: 12px 0px;
  height: auto;
  min-height: 27px;
  padding: 5px 14px;
}

.button-filtrar {
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
}

.button-limpiar {
  border-radius: 10px;
  background: #99abb4;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: 0px;
}

.card-body {
  padding: 0px;
}

#button-guardar {
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  padding-top: 38px;
  display: inline-flex;
  justify-content: end;
  width: 100%;
}

#botonera {
  padding-top: 67px;
  display: flex;
  align-items: center;
  justify-content: end;
}

#botonera button {
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
  min-width: 145px;
  height: 27px;
  padding: 7px 10px;
  color: #fff;
  text-align: center;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 475;
  line-height: normal;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  display: flex;
  align-items: center;
  justify-content: center;
}

#button-eliminar {
  padding-right: 16px;
}

.table {
  margin-top: 22px;
  width: 100%;
  flex-shrink: 0;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.thead-document {
  border-radius: 10px 10px 0px 0px;
  width: 100%;
  height: 40px;
  flex-shrink: 0;
}

.thead-document th {
  background: #006c90;
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.th-1 {
  border-radius: 10px 0px 0px 0px;
  display: flex;
  justify-content: center;
  min-width: 4rem;
}

.th-2 {
  min-width: 57rem;
}

.th-3 {
  min-width: 5rem;
}

.th-5 {
  border-radius: 0px 10px 0px 0px;
  min-width: 5rem;
}

.card {
  background-color: rgba(243, 245, 246, 1);
}
.mr-2 {
  margin-right: 0.5rem !important;
}

tbody tr th {
  color: #99abb4 !important;
  font-size: 0.88rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media (min-width: 768px) {
  /* Aplicar display flex solo cuando el ancho sea mayor a 1000px */
  .buttons-filter {
    display: flex;
  }
}
</style>
